import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectsDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'projects-directory-redirect',
	path: '/projects',
	exact: true,
};
